<app-header></app-header>
<app-about></app-about>
<app-education></app-education> 
<app-contact></app-contact>
<app-steps></app-steps>
<app-footer></app-footer> 
<button mat-fab class="scroll-to-top" (click)="scrollToTop()">
  <mat-icon>arrow_upward</mat-icon>
</button>
